import * as recurringApi from '@/api/recurring'

const state = {
  items: [],
  loading: false,
}

const getters = {
  items: (state) => state.items,
  loading: (state) => state.loading,
}

const actions = {
  async fetchItems({ commit }) {
    commit('SET_LOADING', true)
    try {
      const { data } = await recurringApi.listRecurring()
      commit('SET_ITEMS', data.data.recurring_posts || [])
      return data.data.recurring_posts
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async createItem(_, payload) {
    const { data } = await recurringApi.createRecurring(payload)
    return data.data.recurring_post
  },

  async updateItem(_, { id, payload }) {
    const { data } = await recurringApi.updateRecurring(id, payload)
    return data.data.recurring_post
  },

  async deleteItem(_, id) {
    await recurringApi.deleteRecurring(id)
  },
}

const mutations = {
  SET_ITEMS(state, items) {
    state.items = items
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
